import React from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import './index.css'
import './mobile.css'
import { installMobileShell } from './platform/mobile.js'
import { auth } from './lib/api.js'
import Layout from './components/Layout.jsx'
import Login from './pages/Login.jsx'
import Workbench from './pages/Workbench.jsx'
import Settings from './pages/Settings.jsx'
import Stats from './pages/Stats.jsx'
import Knowledge from './pages/Knowledge.jsx'
import Records from './pages/Records.jsx'
import Monitor from './pages/Monitor.jsx'

function Guard({ children, adminOnly, noAftersales }) {
  const loc = useLocation()
  // 记下从哪来：单独打开的监控大屏登录完要回大屏，不能进工作台（工作台会发心跳，管理员变「在线」）
  if (!auth.token) return <Navigate to="/login" replace state={{ back: loc.pathname }} />
  if ((adminOnly && !auth.isAdmin) || (noAftersales && auth.isAftersales)) return <Navigate to="/workbench" replace />
  return children
}

installMobileShell()

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* 监控大屏的单独网页：不套左栏、不发心跳，开着它不会让管理员账号变「在线」被派单 */}
        <Route path="/screen" element={<Guard adminOnly><Monitor standalone /></Guard>} />
        <Route element={<Guard><Layout /></Guard>}>
          <Route path="/monitor" element={<Guard adminOnly><Monitor /></Guard>} />
          <Route path="/workbench" element={<Workbench />} />
          <Route path="/stats" element={<Guard noAftersales><Stats /></Guard>} />
          <Route path="/records" element={<Guard noAftersales><Records /></Guard>} />
          <Route path="/knowledge" element={<Guard adminOnly><Knowledge /></Guard>} />
          <Route path="/settings" element={<Guard adminOnly><Settings /></Guard>} />
        </Route>
        <Route path="*" element={<Navigate to="/workbench" replace />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
)
